module.exports = __webpack_public_path__ + "img/drug_tablet.10236b87.svg";